export default __webpack_public_path__ + "static/light-bulb-icon-e2f4a370ae65ce96a742f703e73a2d60.svg";